import React from "react";
import { createRoot } from "react-dom/client";
import "./groupNumberTooltip.scss";

let groupNumberTooltipRoot = null;

const GroupNumberTooltip = {
	loadGroupNumber: (className) => {
		GroupNumberTooltip.wrapper(className);
	},

	closeOpenGroupNumber: (event) => {
		const groupNumberContainer = document.querySelectorAll(`.groupnumber__container`);
		if (groupNumberContainer) {
			groupNumberContainer.forEach((node) => {
				// If user clicks outside the element, hide it!
				if (node.classList.contains("open--string")) {
					node.classList.remove("open--string");
				}
			});
		}
	},

	updateGroupNumber: (event, value, dimensions, className, count) => {
		if (groupNumberTooltipRoot) {
			groupNumberTooltipRoot.unmount();
		}
		const groupNumberContainer = document.querySelector(`.${className}`);
		groupNumberContainer.classList.add("open--string");
		groupNumberContainer.setAttribute(
			"style",
			`top: ${event.clientY + window.scrollY + 5 - (63.666666 + count * 19.6666666) / 2}px; left: ${event.clientX + 18}px; position: absolute;`
		);
		groupNumberTooltipRoot = createRoot(groupNumberContainer);
		groupNumberTooltipRoot.render(GroupNumberTooltip.buildGroupNumberContainer(dimensions, value));
	},

	wrapper: (className) => {
		const body = document.querySelector("body");
		const taxonomyContainer = document.querySelector(`.${className}`);
		if (!taxonomyContainer) {
			const wrapper = document.createElement("DIV");
			wrapper.classList.add(className, "groupnumber__container");
			body.appendChild(wrapper);
		}
	},

	buildGroupNumberContainer: (dimensions, value) => {
		return (
			<div className="flex__container flex--ai--c">
				<div className="group-number-string">
					<span style={{ display: "block" }}>Group Number</span>
					<span style={{ display: "block", paddingTop: "8px", paddingBottom: "4px" }}>History:</span>
					{value}
				</div>
			</div>
		);
	}
};

export default GroupNumberTooltip;
